import { useFilterTravelVoucherContext } from "./filter-travel-voucher.context";

export function FilterTravelVoucher() {
  const { dateFilterElement, clearFiltersElement } =
    useFilterTravelVoucherContext();

  return (
    <div>
      <h2>Filters</h2>
      <p className="mb-4">
        Select the following filters you want to apply to the current table.
      </p>

      {dateFilterElement}
      {clearFiltersElement}
    </div>
  );
}